module.exports = __webpack_public_path__ + "img/Fleet Map.336046de.jpeg";